"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionAlliance = require("@/api/distributionAlliance");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AlliancePromoter',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        status: null,
        keyword: '',
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      var params = {
        page: this.query.page,
        size: this.query.size
      };
      if (this.query.status !== null && this.query.status !== '') params.status = this.query.status;
      if (this.query.keyword) params.keyword = this.query.keyword;
      (0, _distributionAlliance.getPromoters)(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.total = Number(res && res.total || 0);
      }).finally(function () {
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.query = {
        status: null,
        keyword: '',
        page: 1,
        size: 20
      };
      this.load(1);
    },
    onSize: function onSize(size) {
      this.query.size = size;
      this.load(1);
    },
    setStatus: function setStatus(row, active) {
      var _this2 = this;
      var tip = active ? "\u786E\u8BA4\u6062\u590D ".concat(row.realName || row.uid, " \u7684\u6DD8\u5BA2\u8EAB\u4EFD\uFF1F") : "\u505C\u7528\u540E\uFF0C".concat(row.realName || row.uid, " \u5728\u6B64\u4E4B\u540E\u652F\u4ED8\u6210\u529F\u7684\u8BA2\u5355\u4E0D\u518D\u4EA7\u751F\u5206\u6DA6\uFF08\u5728\u9014\u7684\u7167\u5E38\u7ED3\u7B97\uFF09\u3002\u786E\u8BA4\u505C\u7528\uFF1F");
      this.$prompt(tip, active ? '恢复淘客' : '停用淘客', {
        inputPlaceholder: '可填写原因，会记进身份变更流水',
        inputValue: ''
      }).then(function (_ref) {
        var value = _ref.value;
        return active ? (0, _distributionAlliance.enablePromoter)(row.uid, value) : (0, _distributionAlliance.disablePromoter)(row.uid, value);
      }).then(function () {
        _this2.$message.success(active ? '已恢复' : '已停用');
        _this2.load();
      }).catch(function () {});
    },
    /** 后端金额一律是「分」 */yuan: function yuan(fen) {
      return ((fen || 0) / 100).toFixed(2);
    }
  }
};